import React, { useState, useContext, useEffect } from 'react'
import MainContext from '@/stores/stores'
import FooterOne from './FooterOne'
import FooterTwo from './FooterTwo'
import FooterThree from './FooterThree'

const FooterComponent: React.FC<any> = (props) => {
  const { info={} } = props
  const [isMobile, setIsMobile] = useState<boolean>(false)

  useEffect(() => {
    isModernPhone().then((isTrue: boolean) => {
      setIsMobile(isTrue)
    })
  }, [])
  const isModernPhone = async () => {
    // 新标准设备检测 API (Chrome 89+)
    let _navigator: any = navigator
    if (_navigator.userAgentData) {
      const { mobile, platform } = await _navigator.userAgentData.getHighEntropyValues(
        ['mobile', 'platform']
      );
      // Android/iOS 平台 + 移动标志
      if (mobile && ['Android', 'iOS'].includes(platform)) {
        const deviceMemory = _navigator.deviceMemory || 0;
        return deviceMemory <= 8; // 排除高性能平板
      }
    }
    
    // 降级处理：屏幕尺寸 + 用户代理验证
    const maxDimension = Math.max(window.screen.width, window.screen.height);
    return maxDimension < 1000 && /Mobile/i.test(_navigator.userAgent);
  }
  return (
    <>
      {
        info.style === 1 ? <FooterOne info={info} onReady={props.onReady}/> : null
      }
      {
        info.style === 2 ? <FooterTwo info={info} onReady={props.onReady}/> : null
      }
      {
        info.style === 3 ? <FooterThree info={info} onReady={props.onReady}/> : null
      }
    </>
  )
}
export default FooterComponent
